import { useSelector, useDispatch } from 'react-redux';
import { setGameId, setMiddle, setHand, appendMiddle, setPlayerTurn, setSomethingHappend, reducePlayerCardCount, resetPlayerCardCount, setPlayersInitially } from '../store/gameSlice';
import useGameMessageHandler from './useGameMessageHandler';
import { connect, disconnect, subscribe, unsubscribe } from '../services/ws-service'
import { append, remove } from '../store/onlineUsersSlice'
import { invite } from '../store/inviteSlice';

const useInviteMessageHandler = () => {
    const onGameMessageReceived = useGameMessageHandler();
    const dispatch = useDispatch();
    const username = useSelector((state) => state.onlineUsers.username)

    const onInviteReceived = (payload) => {
        console.log('%cWsContainer::onInviteReceived:::::::::::::::::::::::::' + payload.body, 'background-color: lightgreen')
        dispatch(invite({
            invitor: JSON.parse(payload.body).invitor,
            lobbyId: JSON.parse(payload.body).lobbyId
        }))
    }
    return onInviteReceived;

}

export default useInviteMessageHandler;